import RefreshIcon from "@mui/icons-material/Refresh";
import ClearIcon from "@mui/icons-material/Clear";
import { MenuAction } from "../components/shared/step-content-box";

interface CreateEntityMenuActionsParams {
  onRefresh: () => void;
  onClearSelection: () => void;
}

const createEntityMenuActions = ({
  onRefresh,
  onClearSelection,
}: CreateEntityMenuActionsParams): MenuAction[] => [
  {
    label: "Refresh Entities",
    icon: <RefreshIcon />,
    onClick: onRefresh,
  },
  {
    label: "Clear Selection",
    icon: <ClearIcon />,
    onClick: onClearSelection,
  },
];

export default createEntityMenuActions;
